module.exports = __webpack_public_path__ + "img/back_length_to_waist.b680e232.png";